import * as Types from '../../../../__generated__/types.gqlgenerated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RecordSurveyImpressionMutationVariables = Types.Exact<{
  input: Types.RecordSurveyImpressionInput;
}>;


export type RecordSurveyImpressionMutation = { __typename?: 'Mutation', recordSurveyImpression?: { __typename?: 'RecordSurveyImpressionPayload', surveyId: string } | null };


export const RecordSurveyImpressionDocument = gql`
    mutation RecordSurveyImpression($input: RecordSurveyImpressionInput!) {
  recordSurveyImpression(input: $input) {
    surveyId
  }
}
    `;
export type RecordSurveyImpressionMutationFn = Apollo.MutationFunction<RecordSurveyImpressionMutation, RecordSurveyImpressionMutationVariables>;

/**
 * __useRecordSurveyImpressionMutation__
 *
 * To run a mutation, you first call `useRecordSurveyImpressionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordSurveyImpressionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordSurveyImpressionMutation, { data, loading, error }] = useRecordSurveyImpressionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecordSurveyImpressionMutation(baseOptions?: Apollo.MutationHookOptions<RecordSurveyImpressionMutation, RecordSurveyImpressionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordSurveyImpressionMutation, RecordSurveyImpressionMutationVariables>(RecordSurveyImpressionDocument, options);
      }
export type RecordSurveyImpressionMutationHookResult = ReturnType<typeof useRecordSurveyImpressionMutation>;
export type RecordSurveyImpressionMutationResult = Apollo.MutationResult<RecordSurveyImpressionMutation>;
export type RecordSurveyImpressionMutationOptions = Apollo.BaseMutationOptions<RecordSurveyImpressionMutation, RecordSurveyImpressionMutationVariables>;